import { useQuery } from "react-query";
import { ChampionshipParticipationAPI } from "api/championshipParticipation";
import { CHAMPIONSHIP_PARTICIPATION } from "helpers/constants";

export default function useChampionshipParticipation(id) {
  return useQuery([CHAMPIONSHIP_PARTICIPATION, id], () =>
    ChampionshipParticipationAPI.getAllForParticipant(id)
  );
}
